import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

export function BettingDialog({ open, setOpen, mode }) {
  const isPaper = mode === "paper";

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      fullWidth
      maxWidth="lg"
    >
      <DialogTitle>
        {isPaper ? "Paper Betting" : "Real Bets"}
      </DialogTitle>

      <DialogContent dividers>
        {isPaper ? (
          <Box>
            <Typography variant="h6" sx={{ mb: 1 }}>
              Paper Betting
            </Typography>

            <Typography color="text.secondary">
              Record, evaluate and analyse your paper bets.
            </Typography>
          </Box>
        ) : (
          <Box sx={{ py: 4, textAlign: "center" }}>
            <Typography variant="h5" sx={{ mb: 2 }}>
              Work in progress
            </Typography>

            <Typography color="text.secondary">
              Recording real bets, combinations and system bets will be
              available here later.
            </Typography>
          </Box>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={() => setOpen(false)}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
